<template>
    <div>
        <v-skeleton-loader
            :aria-busy="false"
            type="card-avatar, article, actions"
        ></v-skeleton-loader>
    </div>
</template>

<script>
export default {}
</script>
